/**
 * Presentation helpers for product history, shared by the admin approval panel
 * (MED-653) and the manufacturer's Edit History panel (MED-682).
 *
 * They live here rather than beside either panel because both render the same
 * recorded rows from the same endpoint: if the two formatted a `from`/`to` pair
 * differently, an admin and a manufacturer could read one audit entry as saying
 * two different things.
 */

const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

export function formatEventDate(value?: string | null) {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB", DATE_TIME_OPTIONS);
}

/**
 * A changed field's before/after value. `from`/`to` arrive as string, number,
 * boolean or null, and an empty value has to read as "nothing was there" rather
 * than as a blank gap in the diff.
 */
export function formatChangeValue(value: string | number | boolean | null) {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "Yes" : "No";

  return String(value);
}
